/*
 * File: /apps/web/src/tasker/redux/modules/rescueTasker.js
 * Project: tr-web
 * Created Date: 2021-02-14
 * Author: Raif
 *
 * Copyright (c) 2021 TaskRabbit, Inc
 */
import { RESCUE_PROFILE } from "tasker/redux/modules/taskerProfile";
import { DateTime } from "luxon";
import { createActionTypesFor } from "util/reducerHelpers";

export const RESCUE_REHIRE_PAYLOAD = createActionTypesFor(
  "rescueProfile",
  "rescueRehirePayload"
);

// schemea
// {
//   [jobId]: {
//     rescueTaskerId: string,
//     timeStamp: dateTime
//     loading: boolean
//   }
// }

const initialState = {};
export default function rescueTakesr(state = initialState, action) {
  switch (action.type) {
    case RESCUE_PROFILE.REQUEST: {
      return action.jobId
        ? {
            ...state,
            [action.jobId]: { ...state[action.jobId], loading: true },
          }
        : state;
    }
    case RESCUE_PROFILE.SUCCESS: {
      // clean up expired entries
      const cutoffTime = DateTime.now().plus({ minutes: -5 });
      let cleanedNewState = { ...state };
      Object.keys(cleanedNewState)
        .filter((jobId) => {
          return cutoffTime > cleanedNewState[jobId].timestamp;
        })
        .forEach((jobId) => {
          const { [jobId]: remove, ...rest } = cleanedNewState;
          cleanedNewState = rest;
        });
      // add new entry to cleaned up state
      const addEntryNewState = {
        ...cleanedNewState,
        [action.jobId]: {
          rescueTaskerId: action.profile?.taskerId,
          timestamp: action.timestamp,
          loading: false,
        },
      };
      return action.jobId ? addEntryNewState : cleanedNewState;
    }
    case "rescueProfile_RESCUE_REHIRE_PAYLOAD": {
      const newState = { ...state };
      Object.keys(newState).forEach((jobId) => {
        if (jobId === action.payload.job_id.toString()) {
          newState[jobId] = {
            ...newState[jobId],
            rehirePayload: action.payload,
          };
        }
      });
      return newState;
    }
    default:
      return state;
  }
}

export const rehirePayload = ({
  secondsBetween,
  job_id,
  invitee_id,
  rabbit_id, // cancelled tasker's id
  taskDate,
  source,
  isRescue,
}) => {
  return {
    type: "rescueProfile_RESCUE_REHIRE_PAYLOAD",
    payload: {
      secondsBetween,
      job_id,
      source,
      invitee_id,
      rabbit_id,
      isRescue,
      taskDate,
    },
  };
};
